import { CommonIntentUtteranceStatus } from "@/util/enum";

export interface ConversationTemplateModel {
	id?: number;
	conversationId?: number;
	type: MasterConversationType;
	text: string;
}

export interface ConversationTagResponseModel {
	id: number;
	name: string;
	value: string;
}

export interface ConversationAssocResponseModel {
	exposureId: string;
	conversationId: number;
	name: string;
	isComplete: boolean;
	isMaster: boolean;
}

export enum MasterConversationType {
	Silent = 1,
	Regular = 2,
	Open = 3,
	Close = 4,
	Other = 5
}

export interface FallbackTypeModel {
	id?: number;
	display: string;
}

export interface UtteranceEntitiesModel {
	id: number;
	name: string;
	order: number;
	itemCount: number;
	conversationCount: number;
	utteranceCount: number;
}

export interface CommonIntentListModel {
	id: number;
	name: string;
	pathCount: number;
	conversationCount: number;
	utteranceCount: number;
}

export interface EntityItemModel {
	id: number;
	value: string;
	order: number;
}

export interface EntityDetailsModel {
	id: number;
	name: string;
	order?: number;
	items: EntityItemModel[];
}

export interface CommonIntentUtteranceModel {
	id: number;
	value: string;
	order: number;
	statusId: CommonIntentUtteranceStatus;
	isPattern: boolean;
	commonEntityName: string | undefined;
	commonEntityId?: number;
}

export interface CommonEntityResponseModel {
	id: number;
	name: string;
	order: number;
	values: EntityItemModel[];
}

export interface CommonIntentDetailsModel {
	id: number;
	name: string;
	commonUtterances: CommonIntentUtteranceModel[];
}
